import { render, staticRenderFns } from "./purchasingOptionsList.vue?vue&type=template&id=06268dac&scoped=true"
import script from "./purchasingOptionsList.vue?vue&type=script&lang=js"
export * from "./purchasingOptionsList.vue?vue&type=script&lang=js"
import style0 from "./purchasingOptionsList.vue?vue&type=style&index=0&id=06268dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06268dac",
  null
  
)

export default component.exports